import React from 'react';
import styled from 'styled-components';

const Grid = styled.div`
  flex: 1 1 ${(props) => props.flexWidth};
  margin-bottom: 24px;
  margin-left: ${(props) => props.columnPosition || '0'};
`;
/**
 * Main purpose of this component is alternative way to render the form builder fields
 * @children - {ReactElement}
 * @sizeOfGrid - {Number}
 * @returns
 * From the layout object
 * We have taken the objects where there are two elements in a row in a seperate array
 * The Logic is,
 * Make the flex to 100% if the size is 2 (2 means full width)
 * make the flex to 50% if the current layoutId is present in the above array
 * if not, make to flex to 100% and put margin to 50%
 */
const getGridWidth = (singleRowArr, layoutId) => {
  if (singleRowArr.includes(layoutId)) {
    return '50%';
  }
  return '100%';
};
const getMargin = (size, singleRowArr, layoutId, xPosition) => {
  if (singleRowArr.includes(layoutId) || size === 2 || xPosition === 0) {
    return '0%';
  }
  return '50%';
};
function CSSGridLayout({
  children,
  sizeOfGrid = 1,
  twoElementsRowLayoutIdsArr,
  layoutId,
  xPosition,
  className
}) {
  const getGridFlexWidth = getGridWidth(twoElementsRowLayoutIdsArr, layoutId);
  return (
    <Grid
      className={className}
      flexWidth={getGridFlexWidth}
      columnPosition={getMargin(
        sizeOfGrid,
        twoElementsRowLayoutIdsArr,
        layoutId,
        xPosition
      )}
    >
      {children}
    </Grid>
  );
}

export default CSSGridLayout;
